export default "__VITE_ASSET__c0f57032__"